<template>
  <v-card>
    <v-card-title style="padding: 1rem">
      <h3>Filtri</h3>
    </v-card-title>
    <v-divider />
    <v-card-text>
      <v-col>

        <v-row>
          <v-select
            v-model="priorityFilter"
            label="Priorità"
            :items="nullablePriorities"
          />
        </v-row>

        <v-row>
          <v-select
            v-model="assigneeFilter"
            label="Assegnata a"
            :items="nullableAssignees"
          />
        </v-row>

        <v-row>
          <v-select
            v-model="authorFilter"
            label="Creata da"
            :items="nullableAuthors"
          />
        </v-row>

        <v-row>
          <v-col>
            <v-switch
              v-model="activeFilter"
              inset
              label="Attive"
            ></v-switch>
          </v-col>
          <v-col>
            <v-switch
              v-model="archivedFilter"
              inset
              label="Archiviate"
            ></v-switch>
          </v-col>
        </v-row>
      </v-col>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn
        color="orange"
        style="margin: 0.5rem 0.5rem 0.5rem auto"
        @click="RESET_NOTE_FILTERS"
      >Reset filtri</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapMutations, mapGetters } from 'vuex'

  export default {
    name: 'Filters',
    props: {
      priorities: { type: Array, default: () => [] },
      assignees: { type: Array, default: () => [] },
      authors: { type: Array, default: () => [] }
    },
    data() {
      return {
        active: true,
        archived: false,
      }
    },

    computed: {
      ...mapGetters({
        filters: 'getNoteFiltes'
      }),

      activeFilter: {
        set(val) {
          this.SET_NOTE_FILTER_ACTIVE(val)
        },
        get() {
          return this.filters.active
        }
      },

      archivedFilter: {
        set(val) {
          this.SET_NOTE_FILTER_ARCHIVED(val)
        },
        get() {
          return this.filters.archived
        }
      },

      priorityFilter: {
        set(val) {
          this.SET_NOTE_FILTER_PRIORITY(val)
        },
        get() {
          return this.filters.priority
        }
      },

      assigneeFilter: {
        set(val) {
          this.SET_NOTE_FILTER_ASSIGNEE(val)
        },
        get() {
          return this.filters.assignee
        }
      },

      authorFilter: {
        set(val) {
          this.SET_NOTE_FILTER_AUTHOR(val)
        },
        get() {
          return this.filters.author
        }
      },

      nullablePriorities() {
        let res = this.priorities.slice(0)
        res.unshift({ value: null, text: 'Tutte' })
        return res
      },
      nullableAssignees() {
        let res = this.assignees

        if (res.length > 0) {
          res[0].text = 'Tutti'
        }

        return res
      },
      nullableAuthors() {
        let res = this.authors

        if (res.length > 0) {
          res[0].text = 'Tutti'
        }

        return res
      }
    },

    methods: {
      ...mapMutations([
        'SET_NOTE_FILTER_ACTIVE',
        'SET_NOTE_FILTER_ARCHIVED',
        'SET_NOTE_FILTER_PRIORITY',
        'SET_NOTE_FILTER_ASSIGNEE',
        'SET_NOTE_FILTER_AUTHOR',

        'RESET_NOTE_FILTERS'
      ]),
    },
  }
</script>

<style>
</style>